import { render, staticRenderFns } from "./SpecialShipImportArea.vue?vue&type=template&id=3c47c3a4&scoped=true&"
import script from "./SpecialShipImportArea.vue?vue&type=script&lang=js&"
export * from "./SpecialShipImportArea.vue?vue&type=script&lang=js&"
import style0 from "./SpecialShipImportArea.vue?vue&type=style&index=0&id=3c47c3a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c47c3a4",
  null
  
)

export default component.exports